package io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.Icons

public val Icons.Playstation3SimpleIcons: ImageVector
    get() {
        if (_playstation3SimpleIcons != null) {
            return _playstation3SimpleIcons!!
        }
        _playstation3SimpleIcons = Builder(name = "Playstation3SimpleIcons", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(15.36f, 9.43f)
                horizontalLineToRelative(-3.15f)
                curveToRelative(-0.97f, 0.0f, -1.45f, 0.6f, -1.45f, 1.38f)
                verticalLineToRelative(2.37f)
                curveToRelative(0.0f, 0.48f, -0.23f, 0.83f, -0.71f, 0.83f)
                lineTo(7.30f, 14.01f)
                arcToRelative(0.04f, 0.04f, 0.0f, false, false, -0.04f, 0.04f)
                verticalLineToRelative(0.47f)
                curveToRelative(0.0f, 0.02f, 0.01f, 0.03f, 0.03f, 0.03f)
                horizontalLineToRelative(3.11f)
                curveToRelative(0.97f, 0.0f, 1.45f, -0.60f, 1.45f, -1.38f)
                verticalLineToRelative(-2.36f)
                curveToRelative(0.0f, -0.48f, 0.22f, -0.83f, 0.71f, -0.83f)
                horizontalLineToRelative(2.78f)
                curveToRelative(0.02f, 0.0f, 0.04f, -0.01f, 0.04f, -0.03f)
                verticalLineToRelative(-0.48f)
                curveToRelative(0.0f, -0.02f, -0.02f, -0.04f, -0.04f, -0.04f)
                close()
                moveTo(6.10f, 9.43f)
                lineTo(0.04f, 9.43f)
                curveToRelative(-0.02f, 0.0f, -0.04f, 0.02f, -0.04f, 0.04f)
                verticalLineToRelative(0.48f)
                curveToRelative(0.0f, 0.02f, 0.02f, 0.04f, 0.04f, 0.04f)
                horizontalLineToRelative(5.69f)
                curveToRelative(0.48f, 0.0f, 0.71f, 0.35f, 0.71f, 0.83f)
                reflectiveCurveToRelative(-0.23f, 0.83f, -0.71f, 0.83f)
                lineTo(1.23f, 11.64f)
                curveToRelative(-0.7f, 0.0f, -1.23f, 0.59f, -1.23f, 1.37f)
                verticalLineToRelative(1.51f)
                curveToRelative(0.0f, 0.02f, 0.02f, 0.04f, 0.04f, 0.04f)
                horizontalLineToRelative(1.03f)
                curveToRelative(0.02f, 0.0f, 0.04f, -0.02f, 0.04f, -0.04f)
                verticalLineToRelative(-1.51f)
                curveToRelative(0.0f, -0.48f, 0.28f, -0.82f, 0.68f, -0.82f)
                lineTo(6.1f, 12.19f)
                curveToRelative(0.97f, 0.0f, 1.44f, -0.59f, 1.44f, -1.37f)
                curveToRelative(0.0f, -0.78f, -0.47f, -1.38f, -1.44f, -1.38f)
                close()
                moveTo(23.55f, 11.93f)
                arcToRelative(0.04f, 0.04f, 0.0f, false, true, 0.0f, -0.06f)
                curveToRelative(0.3f, -0.25f, 0.45f, -0.63f, 0.45f, -1.06f)
                curveToRelative(0.0f, -0.78f, -0.47f, -1.38f, -1.45f, -1.38f)
                horizontalLineToRelative(-6.06f)
                curveToRelative(-0.02f, 0.0f, -0.04f, 0.02f, -0.04f, 0.04f)
                verticalLineToRelative(0.48f)
                curveToRelative(0.0f, 0.02f, 0.02f, 0.04f, 0.04f, 0.04f)
                horizontalLineToRelative(5.7f)
                curveToRelative(0.48f, 0.0f, 0.72f, 0.35f, 0.72f, 0.83f)
                reflectiveCurveToRelative(-0.23f, 0.83f, -0.71f, 0.83f)
                horizontalLineToRelative(-5.7f)
                curveToRelative(-0.02f, 0.0f, -0.04f, 0.02f, -0.04f, 0.04f)
                verticalLineToRelative(0.48f)
                curveToRelative(0.0f, 0.02f, 0.02f, 0.03f, 0.04f, 0.03f)
                horizontalLineToRelative(5.7f)
                curveToRelative(0.63f, 0.01f, 0.71f, 0.62f, 0.71f, 0.93f)
                verticalLineToRelative(0.06f)
                curveToRelative(0.0f, 0.49f, -0.23f, 0.83f, -0.71f, 0.83f)
                horizontalLineToRelative(-5.7f)
                curveToRelative(-0.02f, 0.0f, -0.04f, 0.02f, -0.04f, 0.03f)
                verticalLineToRelative(0.48f)
                curveToRelative(0.0f, 0.02f, 0.02f, 0.04f, 0.04f, 0.04f)
                horizontalLineToRelative(6.05f)
                curveToRelative(0.97f, 0.0f, 1.45f, -0.65f, 1.45f, -1.38f)
                verticalLineToRelative(-0.06f)
                curveToRelative(0.0f, -0.47f, -0.15f, -0.92f, -0.45f, -1.19f)
                close()
            }
        }
        .build()
        return _playstation3SimpleIcons!!
    }

private var _playstation3SimpleIcons: ImageVector? = null
